import { FEATURES } from "@proj-common/const"
import { planFeatureAvailability, planFeatureID } from "@proj-common/enums"
import { IPlan } from "@proj-common/types"

export const StarterPlan: IPlan = {
    paddleProductData: {
        name: "Starter",
        taxCategory: "saas",
        customData: {
            lookup_key: "starter",
            type: "plan",
            order: "1",
        },
        type: "standard",
    },
    paddlePriceData: [
        {
            //productId: null, // need to change to actual product ID after creation
            description: "Starter Monthly",
            name: "Starter Monthly",
            unitPrice: {
                amount: "800",
                currencyCode: "USD"
            },
            billingCycle: {
                frequency: 1,
                interval: "month",
            },
            quantity: {
                maximum: 1,
                minimum: 1,
            },
            taxMode: "external",
            // trialPeriod: {
            //     frequency: 30,
            //     interval: "day",
            // },
            customData: {
                lookup_key: "starter_monthly",
            },
            type: "standard",
        },
        {
            //productId: null, // need to change to actual product ID after creation
            description: "Starter Monthly with trial",
            name: "Starter Monthly",
            unitPrice: {
                amount: "800",
                currencyCode: "USD"
            },
            billingCycle: {
                frequency: 1,
                interval: "month",
            },
            quantity: {
                maximum: 1,
                minimum: 1,
            },
            taxMode: "external",
            trialPeriod: {
                frequency: 30,
                interval: "day",
            },
            customData: {
                lookup_key: "starter_monthly_trial",
            },
            type: "standard",
        },
        {
            //productId: null, // need to change to actual product ID after creation
            description: "Starter Yearly",
            name: "Starter Yearly",
            unitPrice: {
                amount: "8400",
                currencyCode: "USD"
            },
            billingCycle: {
                frequency: 1,
                interval: "year",
            },
            quantity: {
                maximum: 1,
                minimum: 1,
            },
            taxMode: "external",
            // trialPeriod: {
            //     frequency: 30,
            //     interval: "day",
            // },
            customData: {
                lookup_key: "starter_yearly",
            },
            type: "standard",
        },
        {
            //productId: null, // need to change to actual product ID after creation
            description: "Starter Yearly with trial",
            name: "Starter Yearly",
            unitPrice: {
                amount: "8400",
                currencyCode: "USD"
            },
            billingCycle: {
                frequency: 1,
                interval: "year",
            },
            quantity: {
                maximum: 1,
                minimum: 1,
            },
            taxMode: "external",
            trialPeriod: {
                frequency: 30,
                interval: "day",
            },
            customData: {
                lookup_key: "starter_yearly_trial",
            },
            type: "standard",
        },
    ],
    paddleAddonPriceData: [
        {
            //productId: null, // need to change to actual product ID after creation
            description: "Enable Export to Application for one event",
            name: "Enable Export to Application for one event",
            unitPrice: {
                amount: "400",
                currencyCode: "USD"
            },
            billingCycle: null,
            quantity: {
                maximum: 1,
                minimum: 1,
            },
            taxMode: "external",
            customData: {
                lookup_key: "starter_addon_export_app",
            },
            type: "standard",
        },
        {
            //productId: addonsProduct.id,
            description: "Enable Powerpoint Reporting for one event",
            name: "Enable Powerpoint Reporting for one event",
            unitPrice: {
                amount: "1800",
                currencyCode: "USD"
            },
            billingCycle: null,
            quantity: {
                maximum: 1,
                minimum: 1,
            },
            taxMode: "external",
            customData: {
                lookup_key: "starter_addon_ppt_reporting",
            },
            type: "standard",
        },
        {
            // productId: addonsProduct.id,
            description: "Enable AI company role participants for one event",
            name: "Enable AI company role participants for one event",
            unitPrice: {
                amount: "800",
                currencyCode: "USD"
            },
            billingCycle: null,
            quantity: {
                maximum: 1,
                minimum: 1,
            },
            taxMode: "external",
            customData: {
                lookup_key: "starter_addon_ai_bots",
            },
            type: "standard",
        }
    ],
    details: {
        small_text: "For individuals looking to run simple brainstorming sessions with occasional need for advanced features.",
        CTA_text: "Get Started",
    },
    features: [
        {
            id: FEATURES.sessions_per_month.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.sessions_per_month.description,
            label: FEATURES.sessions_per_month.label,
            value: 5,
        },
        {
            id: FEATURES.max_participants_per_session.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.max_participants_per_session.description,
            label: FEATURES.max_participants_per_session.label,
            value: 10,
        },
        {
            id: FEATURES.export_basic.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.export_basic.description,
            label: FEATURES.export_basic.label,
        },
        {
            id: FEATURES.export_apps.id,
            availability: planFeatureAvailability.optional,
            description: FEATURES.export_apps.description,
            label: FEATURES.export_apps.label,
            lookup_key: "starter_addon_export_app"
        },
        {
            id: FEATURES.reporting_html.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.reporting_html.description,
            label: FEATURES.reporting_html.label,
        },
        {
            id: FEATURES.reporting_powerpoint.id,
            availability: planFeatureAvailability.optional,
            description: FEATURES.reporting_powerpoint.description,
            label: FEATURES.reporting_powerpoint.label,
            lookup_key: "starter_addon_ppt_reporting",
        },
        {
            id: FEATURES.ai_ideas_grouping.id,
            availability: planFeatureAvailability.included,
            description: FEATURES.ai_ideas_grouping.description,
            label: FEATURES.ai_ideas_grouping.label,
        },
        {
            id: FEATURES.ai_custom_participants.id,
            availability: planFeatureAvailability.optional,
            description: FEATURES.ai_custom_participants.description,
            label: FEATURES.ai_custom_participants.label,
            lookup_key: "starter_addon_ai_bots",
        },
    ]
}